import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { AppContextProvider } from './context/AppContext';
import { PageLoader } from './components/page-loader/PageLoader';

const App = React.lazy(() => import('./App'));

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <AppContextProvider>
      <Suspense fallback={<PageLoader shouldDisplayLoader />}>
        <App />
      </Suspense>
    </AppContextProvider>
  </React.StrictMode>
);
